import { render, staticRenderFns } from "./FloatingActionsComponent.vue?vue&type=template&id=00ff8090&"
import script from "./FloatingActionsComponent.vue?vue&type=script&lang=js&"
export * from "./FloatingActionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports